import React, {useState, useEffect} from 'react';
import {motion} from 'framer-motion';
import Header from './components/Header';
import RACOAPTERETOForm from './components/RACOAPTERETOForm';
import PromptDisplay from './components/PromptDisplay';
import Footer from './components/Footer';
import InstallPWA from './components/InstallPWA';
import HelpModal from './components/HelpModal';
import {ThemeProvider} from './context/ThemeContext';
import './App.css';

function App() {
  const [promptData, setPromptData] = useState({});
  const [generatedPrompt, setGeneratedPrompt] = useState('');
  const [showHelp, setShowHelp] = useState(false);
  const [showPrompt, setShowPrompt] = useState(false);

  // Mostrar automáticamente la sección de prompt cuando se genera uno
  useEffect(() => {
    if (generatedPrompt) {
      setShowPrompt(true);
    }
  }, [generatedPrompt]);

  useEffect(() => {
    // Register service worker
    if ('serviceWorker' in navigator) {
      window.addEventListener('load', () => {
        navigator.serviceWorker.register('/sw.js')
          .then((registration) => {
            console.log('SW registered: ', registration);
          })
          .catch((registrationError) => {
            console.log('SW registration failed: ', registrationError);
          });
      });
    }
  }, []);

  // Función para manejar la regeneración del prompt
  const handleRegeneratePrompt = () => {
    // Esta función simplemente reutiliza los datos actuales para generar un nuevo prompt
    // sin necesidad de modificar el formulario
    if (Object.keys(promptData).length > 0) {
      const filledFields = Object.entries(promptData).filter(([_, value]) => value?.trim());
      
      if (filledFields.length === 0) {
        alert('Por favor, completa al menos un campo antes de generar el prompt.');
        return;
      }
      
      // Reutilizar los datos para generar un nuevo prompt
      let prompt = '';
      filledFields.forEach(([key, value], index) => {
        prompt += value.trim() + (index < filledFields.length - 1 ? '. ' : '.');
      });
      
      setGeneratedPrompt(prompt.trim());
    }
  };

  return (
    <ThemeProvider>
      <div className="min-h-screen bg-gradient-to-br from-blue-50 to-pink-50 dark:from-gray-900 dark:to-gray-800 transition-colors duration-300 flex flex-col w-full overflow-x-hidden">
        <Header onShowHelp={() => setShowHelp(true)} />
        
        <main className="container mx-auto px-3 sm:px-4 py-4 sm:py-8 max-w-6xl flex-grow overflow-x-hidden">
          <motion.div
            initial={{opacity: 0, y: 20}}
            animate={{opacity: 1, y: 0}}
            transition={{duration: 0.6}}
            className="space-y-6 sm:space-y-8 w-full overflow-x-hidden"
          >
            <InstallPWA />
            
            <RACOAPTERETOForm 
              promptData={promptData}
              setPromptData={setPromptData}
              setGeneratedPrompt={setGeneratedPrompt}
            />
            
            {showPrompt && generatedPrompt && (
              <PromptDisplay 
                prompt={generatedPrompt}
                promptData={promptData}
                onEdit={() => {
                  /* Permitir volver a editar sin limpiar el prompt */
                  window.scrollTo({top: 0, behavior: 'smooth'});
                }}
                onRegenerate={handleRegeneratePrompt}
              />
            )}
          </motion.div>
        </main>
        
        <Footer />
        
        {showHelp && (
          <HelpModal onClose={() => setShowHelp(false)} />
        )}
      </div>
    </ThemeProvider>
  );
}

export default App;